import React from "react"

function FirstStartsOnTime(){
    return <React.Fragment>
        <iframe title="San Antonio FSOT_v2" width="1400" height="800" src="https://app.powerbi.com/reportEmbed?reportId=367aa2a0-1c3a-4a01-9531-b1472e250295&autoAuth=true&ctid=49423d5d-8d49-4128-b53d-59537808f6ac&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtYi1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ%3D%3D" allowFullScreen={true}></iframe>
    </React.Fragment>
}

export{FirstStartsOnTime}